import {
  Address,
  AdesionTerms,
  QuestionEight,
  QuestionEleven,
  QuestionTwo,
  QuestionFifteen,
  QuestionFive,
  QuestionFour,
  QuestionFourteen,
  QuestionNine,
  QuestionOne,
  QuestionSeven,
  QuestionSeventeen,
  QuestionSix,
  QuestionSixteen,
  QuestionTen,
  QuestionThirteen,
  QuestionThree,
  QuestionTwelve,
  QuestionEighteen,
} from 'components/DueDiligence/Questions'

export const questionsMap = [
  { component: Address, key: 'address' },
  { component: QuestionOne, key: 'social_networks' },
  { component: QuestionTwo, key: 'financial_activities' },
  { component: QuestionThree, key: 'environment_related_activities' },
  { component: QuestionFour, key: 'external_activities' },
  { component: QuestionFive, key: 'national_product_offering_activities' },
  { component: QuestionSix, key: 'international_product_offering_activities' },
  { component: QuestionSeven, key: 'representation_activities' },
  { component: QuestionEight, key: 'automation_activities' },
  { component: QuestionNine, key: 'kinship_xp' },
  { component: QuestionTen, key: 'pep_relationship' },
  { component: QuestionEleven, key: 'attorney_activities' },
  { component: QuestionTwelve, key: 'third_party_investments' },
  { component: QuestionThirteen, key: 'court_lawsuit_cvm_bacen_sfn' },
  { component: QuestionFourteen, key: 'environmental_court_lawsuit' },
  { component: QuestionFifteen, key: 'criminal_court_lawsuit' },
  { component: QuestionSixteen, key: 'negative_media' },
  { component: QuestionSeventeen, key: 'restrictive_list' },
  { component: QuestionEighteen, key: 'relation_with_another_companies' },
  { component: AdesionTerms, key: 'terms_agreement' },
]
